import { useState, useEffect, useMemo } from "react";
import { gql, useSubscription } from "@apollo/client";
import { useLocation } from "react-router-dom";

const SYNC_SUB = gql`
  subscription SyncGuild($id: Int!, $tag: Int, $zone: Int!, $force: Boolean) {
    sync(guildId: $id, tag: $tag, zone: $zone, forceAnalysis: $force) {
      kind
      totalLogs
      remainingLogs
    }
  }
`;

export default function Sync({
  syncCallback,
  id,
  tag,
  zone,
}: {
  id: number;
  syncCallback: () => void;
  tag?: number;
  zone: number;
}) {
  const loc = useLocation();
  const force = useMemo(() => loc.search.includes('force=true'), [loc.search]);
  const { error, data } = useSubscription(SYNC_SUB, {
    variables: { id, tag, zone, force },
  });

  const [cancelled, setCancelled] = useState(false);
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    if (data && data.sync.kind === "COMPLETE") {
      syncCallback();
    }
  }, [data, syncCallback]);

  useEffect(() => {
    if ((data && data.sync.kind === "CANCELLED") || error) {
      setCancelled(true);
      if (progress === 0) {
        setProgress(100);
      }
    } else if (data && data.sync.remainingLogs && data.sync.totalLogs) {
      const new_prog =
        (1 - data.sync.remainingLogs / data.sync.totalLogs) * 100;
      setProgress(new_prog);
    }
  }, [data, error]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="m-auto mt-10 max-w-xl">
      <span>{cancelled ? "Unable to import logs" : "Importing Logs..."}</span>
      <div className="h-3 relative max-w-xl rounded-full overflow-hidden">
        <div className="w-full h-full bg-gray-200 absolute"></div>
        <div
          className={`h-full absolute ${
            cancelled ? "bg-red-500" : "bg-blue-500"
          }`}
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    </div>
  );
}
